import React from "react";
import { useNavigate } from "react-router-dom";
import platformIcon from "assets/images/icons/socials/instagram.png";

import downloadIcon from "assets/images/icons/utilities/download.png";
import checkIcon from "assets/images/icons/utilities/check-mark.png";
import SearchCard from "examples/Cards/SearchCard";

function InstagramResultCard({ result, isInSocialStash, fetchUsageData, canDownload, featureName, planRequired, usageRaw, isWorkflow }) {
  const navigate = useNavigate();

  /**
   * Navigate to the Social Stash page.
   */
  const handleViewInSocialStash = () => {
    navigate("/social-stash");
  };

  return (
    <SearchCard
      platformIcon={platformIcon}
      verifiedIcon={null} // Instagram verification is not available yet
      downloadIcon={downloadIcon}
      checkIcon={checkIcon}
      result={{
        ...result,
        picture: result.profile_picture_url, // Use Instagram profile picture URL
      }}
      countLabel="Followers"
      isInSocialStash={isInSocialStash}
      onViewInSocialStash={handleViewInSocialStash}
      fetchUsageData={fetchUsageData}
      canDownload={canDownload}
      featureName={featureName}
      planRequired={planRequired}
      usageRaw={usageRaw}
      isWorkflow={isWorkflow}
    />
  );
}

export default InstagramResultCard;
